import { useMemo } from "react";
import { useServiceContext } from "../../contexts/services/hooks/use-services-context";

export type Consents = {
    hasAllRequiredConsents: (
        didomiUserProfile: didomiUserProfile,
        consentShouldBeCollected: boolean,
    ) => Promise<boolean>;
};

/** `undefined` tant que la session n'est pas créée. */
export function useConsents(): Consents | undefined {
    const consentManager = useServiceContext().sdk?.consentManager;

    return useMemo<Consents | undefined>(
        () =>
            consentManager
                ? {
                      hasAllRequiredConsents: (...args) =>
                          consentManager.hasAllRequiredConsents(...args),
                  }
                : undefined,
        [consentManager],
    );
}
